<template>
  <v-app style="background-color: #f8f9fb">
    <!-- Diálogo de progresso -->
    <v-dialog v-model="showProgress" persistent max-width="300">
      <v-card>
        <v-card-title> Baixando arquivo... </v-card-title>
        <v-card-text>
          <!-- Coloque aqui qualquer indicador de progresso que você deseja mostrar -->
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilter" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center">
          A Diferença entre as datas não pode ser superior a 90 dias.
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showFilter = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilterDownload" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center"> Em Manutenção </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showFilterDownload = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container style="background-color: #f8f9fb">
      <v-col cols="12">
        <filtro-component
          :modos="modos"
          :calendar="'mes'"
          @filtrar="filterData"
        ></filtro-component>
      </v-col>
    </v-container>

    <v-container
      style="background-color: #eee"
      id="financeiro"
      fluid
      tag="section"
    >
      <template>
        <v-tabs v-model="activeTab">
          <!-- Abas -->
          <v-tab>Receita</v-tab>
          <v-tab>Atendimentos com autorizações</v-tab>
          <v-tab>Detalhamento de óbitos</v-tab>

          <!-- Conteúdo das Abas -->
          <v-tabs-items v-model="activeTab">
            <br />
            <v-tab-item>
              <v-row>
                <v-col cols="6">
                  <base-material-card
                    icon="mdi-toolbox-outline"
                    title="Serviços funerários particulares"
                    color="green"
                    style="
                      margin-top: 20px !important;
                      padding-top: 10px !important;
                    "
                    class="px-5 py-0"
                  >
                    <v-data-table
                      :headers="ranking_one"
                      :items="servicos_particulares"
                      :items-per-page="10"
                      items-per-page-text="Linhas por página"
                      class="elevation-0"
                    >
                      <br />
                      <br />
                      <br />

                      <template v-slot:top>
                        <v-progress-linear
                          v-if="isLoading"
                          indeterminate
                          color="green"
                        ></v-progress-linear>
                      </template>

                      <template v-slot:item="row">
                        <tr
                          :class="{
                            'cor-row': row.index % 2 !== 0,
                            'primeira-linha-estilo': row.index === 0,
                          }"
                        >
                          <td class="linha" style="width: 20%; font-size: 14px">
                            {{ row.item.id_atendimento }}
                          </td>
                          <td class="linha" style="width: 50%; font-size: 14px">
                            {{ row.item.falecido }}
                          </td>
                          <td class="linha" style="width: 30%; font-size: 14px">
                            {{
                              parseFloat(row.item.valor).toLocaleString(
                                "pt-BR",
                                {
                                  style: "currency",
                                  currency: "BRL",
                                }
                              )
                            }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>

                    <br />

                    <!-- Totalizador -->
                    <div class="d-flex flex-column align-end">
                      <span style="font-size: 18px; margin-bottom: 8px">
                        Qtd.:
                        <strong>{{ servicos_particulares.length }}</strong>
                      </span>
                      <span style="font-size: 18px">
                        Total:
                        <strong>{{
                          totalValorSP.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}</strong>
                      </span>
                    </div>

                    <br />
                  </base-material-card>
                </v-col>

                <v-col cols="6">
                  <base-material-card
                    icon="mdi-toolbox-outline"
                    title="Serviços Particulares - Itens"
                    color="green"
                    style="
                      margin-top: 20px !important;
                      padding-top: 10px !important;
                    "
                    class="px-5 py-0"
                  >
                    <v-data-table
                      :headers="ranking_six"
                      :items="servicos_particulares_itens"
                      :items-per-page="10"
                      items-per-page-text="Linhas por página"
                      class="elevation-0"
                    >
                      <br />
                      <br />
                      <br />

                      <template v-slot:top>
                        <v-progress-linear
                          v-if="isLoading"
                          indeterminate
                          color="green"
                        ></v-progress-linear>
                      </template>

                      <template v-slot:item="row">
                        <tr
                          :class="{
                            'cor-row': row.index % 2 !== 0,
                            'primeira-linha-estilo': row.index === 0,
                          }"
                        >
                          <td class="linha" style="width: 50%; font-size: 14px">
                            {{ row.item.agrupamento }}
                          </td>

                          <td class="linha" style="width: 15%; font-size: 14px">
                            {{ row.item.total }}
                          </td>

                          <td
                            class="linha"
                            style="width: 35%; font-size: 14px"
                            :style="
                              parseFloat(row.item.valor) < 0
                                ? 'color: #d32f2f; font-weight: bold; '
                                : ''
                            "
                          >
                            {{
                              parseFloat(row.item.valor).toLocaleString(
                                "pt-BR",
                                {
                                  style: "currency",
                                  currency: "BRL",
                                }
                              )
                            }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>

                    <br />

                    <!-- Totalizador -->
                    <div class="d-flex flex-column align-end">
                      <span style="font-size: 18px; margin-bottom: 8px">
                        Qtd.:
                        <strong>{{
                          servicos_particulares_itens.reduce(
                            (sum, item) => sum + (item.total || 0),
                            0
                          )
                        }}</strong>
                      </span>
                      <span style="font-size: 18px">
                        Total:
                        <strong>{{
                          totalValorVI.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}</strong>
                      </span>
                    </div>

                    <br />
                  </base-material-card>
                </v-col>

                <v-col cols="6">
                  <base-material-card
                    icon="mdi-toolbox-outline"
                    title="Serviços Plano Previda"
                    color="green"
                    style="
                      margin-top: 20px !important;
                      padding-top: 10px !important;
                    "
                    class="px-5 py-0"
                  >
                    <v-data-table
                      :headers="ranking_one"
                      :items="servicos_plano_previda"
                      :items-per-page="10"
                      items-per-page-text="Linhas por página"
                      class="elevation-0"
                    >
                      <br />
                      <br />
                      <br />

                      <template v-slot:top>
                        <v-progress-linear
                          v-if="isLoading"
                          indeterminate
                          color="green"
                        ></v-progress-linear>
                      </template>

                      <template v-slot:item="row">
                        <tr
                          :class="{
                            'cor-row': row.index % 2 !== 0,
                            'primeira-linha-estilo': row.index === 0,
                          }"
                        >
                          <td class="linha" style="width: 20%; font-size: 14px">
                            {{ row.item.id_atendimento }}
                          </td>
                          <td class="linha" style="width: 50%; font-size: 14px">
                            {{ row.item.falecido }}
                          </td>
                          <td class="linha" style="width: 30%; font-size: 14px">
                            {{
                              parseFloat(row.item.valor).toLocaleString(
                                "pt-BR",
                                {
                                  style: "currency",
                                  currency: "BRL",
                                }
                              )
                            }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>

                    <br />

                    <!-- Totalizador -->
                    <div class="d-flex flex-column align-end">
                      <span style="font-size: 18px; margin-bottom: 8px">
                        Qtd.:
                        <strong>{{ servicos_plano_previda.length }}</strong>
                      </span>
                      <span style="font-size: 18px">
                        Total:
                        <strong>{{
                          totalValorSPP.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}</strong>
                      </span>
                    </div>

                    <br />
                  </base-material-card>
                </v-col>

                <v-col cols="6">
                  <base-material-card
                    icon="mdi-toolbox-outline"
                    title="Serviços Plano Previda - Itens"
                    color="green"
                    style="
                      margin-top: 20px !important;
                      padding-top: 10px !important;
                    "
                    class="px-5 py-0"
                  >
                    <v-data-table
                      :headers="ranking_six"
                      :items="servicos_plano_previda_itens"
                      :items-per-page="10"
                      items-per-page-text="Linhas por página"
                      class="elevation-0"
                    >
                      <br />
                      <br />
                      <br />

                      <template v-slot:top>
                        <v-progress-linear
                          v-if="isLoading"
                          indeterminate
                          color="green"
                        ></v-progress-linear>
                      </template>

                      <template v-slot:item="row">
                        <tr
                          :class="{
                            'cor-row': row.index % 2 !== 0,
                            'primeira-linha-estilo': row.index === 0,
                          }"
                        >
                          <td class="linha" style="width: 55%; font-size: 14px">
                            {{ row.item.agrupamento }}
                          </td>

                          <td class="linha" style="width: 15%; font-size: 14px">
                            {{ row.item.total }}
                          </td>

                          <td class="linha" style="width: 30%; font-size: 14px">
                            {{
                              parseFloat(row.item.valor).toLocaleString(
                                "pt-BR",
                                {
                                  style: "currency",
                                  currency: "BRL",
                                }
                              )
                            }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>

                    <br />

                    <!-- Totalizador -->
                    <div class="d-flex flex-column align-end">
                      <span style="font-size: 18px; margin-bottom: 8px">
                        Qtd.:
                        <strong>{{
                          servicos_plano_previda_itens.reduce(
                            (sum, item) => sum + (item.total || 0),
                            0
                          )
                        }}</strong>
                      </span>
                      <span style="font-size: 18px">
                        Total:
                        <strong>{{
                          totalValorSPPI.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}</strong>
                      </span>
                    </div>

                    <br />
                  </base-material-card>
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item>
              <v-row>
                <v-col cols="6">
                  <base-material-card
                    icon="mdi-toolbox-outline"
                    title="Pequeninos"
                    color="green"
                    style="
                      margin-top: 20px !important;
                      padding-top: 10px !important;
                    "
                    class="px-5 py-0"
                  >
                    <v-data-table
                      :headers="ranking_one"
                      :items="servicos_pequeninos"
                      :items-per-page="10"
                      items-per-page-text="Linhas por página"
                      class="elevation-0"
                    >
                      <br />
                      <br />
                      <br />

                      <template v-slot:top>
                        <v-progress-linear
                          v-if="isLoading"
                          indeterminate
                          color="green"
                        ></v-progress-linear>
                      </template>

                      <template v-slot:item="row">
                        <tr
                          :class="{
                            'cor-row': row.index % 2 !== 0,
                            'primeira-linha-estilo': row.index === 0,
                          }"
                        >
                          <td class="linha" style="width: 20%; font-size: 14px">
                            {{ row.item.id_atendimento }}
                          </td>
                          <td class="linha" style="width: 50%; font-size: 14px">
                            {{ row.item.falecido }}
                          </td>
                          <td class="linha" style="width: 30%; font-size: 14px">
                            {{
                              parseFloat(row.item.valor).toLocaleString(
                                "pt-BR",
                                {
                                  style: "currency",
                                  currency: "BRL",
                                }
                              )
                            }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>

                    <br />

                    <!-- Totalizador -->
                    <div class="d-flex flex-column align-end">
                      <span style="font-size: 18px; margin-bottom: 8px">
                        Qtd.: <strong>{{ servicos_pequeninos.length }}</strong>
                      </span>
                      <span style="font-size: 18px">
                        Total:
                        <strong>{{
                          totalValorPQ.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}</strong>
                      </span>
                    </div>

                    <br />
                  </base-material-card>
                </v-col>

                <v-col cols="6">
                  <base-material-card
                    icon="mdi-toolbox-outline"
                    title="Serviços Pequeninos - Itens"
                    color="green"
                    style="
                      margin-top: 20px !important;
                      padding-top: 10px !important;
                    "
                    class="px-5 py-0"
                  >
                    <v-data-table
                      :headers="ranking_six"
                      :items="servicos_pequeninos_itens"
                      :items-per-page="10"
                      items-per-page-text="Linhas por página"
                      class="elevation-0"
                    >
                      <br />
                      <br />
                      <br />

                      <template v-slot:top>
                        <v-progress-linear
                          v-if="isLoading"
                          indeterminate
                          color="green"
                        ></v-progress-linear>
                      </template>

                      <template v-slot:item="row">
                        <tr
                          :class="{
                            'cor-row': row.index % 2 !== 0,
                            'primeira-linha-estilo': row.index === 0,
                          }"
                        >
                          <td class="linha" style="width: 60%; font-size: 14px">
                            {{ row.item.agrupamento }}
                          </td>

                          <td class="linha" style="width: 10%; font-size: 14px">
                            {{ row.item.total }}
                          </td>

                          <td class="linha" style="width: 30%; font-size: 14px">
                            {{
                              parseFloat(row.item.valor).toLocaleString(
                                "pt-BR",
                                {
                                  style: "currency",
                                  currency: "BRL",
                                }
                              )
                            }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>

                    <br />

                    <!-- Totalizador -->
                    <div class="d-flex flex-column align-end">
                      <span style="font-size: 18px; margin-bottom: 8px">
                        Qtd.:
                        <strong>{{
                          servicos_pequeninos_itens.reduce(
                            (sum, item) => sum + (item.total || 0),
                            0
                          )
                        }}</strong>
                      </span>
                      <span style="font-size: 18px">
                        Total:
                        <strong>{{
                          totalValorPQI.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}</strong>
                      </span>
                    </div>

                    <br />
                  </base-material-card>
                </v-col>

                <v-col cols="6">
                  <base-material-card
                    icon="mdi-toolbox-outline"
                    title="Liberação de serviço com pendência financeira"
                    color="green"
                    style="
                      margin-top: 20px !important;
                      padding-top: 10px !important;
                    "
                    class="px-5 py-0"
                  >
                    <v-data-table
                      :headers="ranking_five"
                      :items="liberacao_servicos_carencia"
                      :items-per-page="10"
                      items-per-page-text="Linhas por página"
                      class="elevation-0"
                    >
                      <br />
                      <br />
                      <br />

                      <template v-slot:top>
                        <v-progress-linear
                          v-if="isLoading"
                          indeterminate
                          color="green"
                        ></v-progress-linear>
                      </template>

                      <template v-slot:item="row">
                        <tr
                          :class="{
                            'cor-row': row.index % 2 !== 0,
                            'primeira-linha-estilo': row.index === 0,
                          }"
                        >
                          <td class="linha" style="width: 20%; font-size: 14px">
                            {{ row.item.id_atendimento }}
                          </td>
                          <td class="linha" style="width: 30%; font-size: 14px">
                            {{ row.item.falecido }}
                          </td>
                          <td class="linha" style="width: 20%; font-size: 14px">
                            {{
                              parseFloat(row.item.valor).toLocaleString(
                                "pt-BR",
                                {
                                  style: "currency",
                                  currency: "BRL",
                                }
                              )
                            }}
                          </td>

                          <td class="linha" style="width: 30%; font-size: 14px">
                            {{ row.item.item }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>

                    <br />

                    <!-- Totalizador -->
                    <div class="d-flex flex-column align-end">
                      <span style="font-size: 18px; margin-bottom: 8px">
                        Qtd.:
                        <strong>{{
                          liberacao_servicos_carencia.length
                        }}</strong>
                      </span>
                      <span style="font-size: 18px">
                        Total:
                        <strong>{{
                          totalValorLSC.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}</strong>
                      </span>
                    </div>

                    <br />
                  </base-material-card>
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item>
              <v-row>
                <v-col cols="12">
                  <base-material-card
                    icon="mdi-toolbox-outline"
                    title="Detalhamento dos Óbitos"
                    color="green"
                    style="
                      margin-top: 20px !important;
                      padding-top: 10px !important;
                    "
                    class="px-5 py-0"
                  >
                    <v-data-table
                      :headers="ranking_three"
                      :items="detalhe_obito"
                      :items-per-page="10"
                      items-per-page-text="Linhas por página"
                      class="elevation-0"
                    >
                      <br />
                      <br />
                      <br />

                      <template v-slot:top>
                        <v-progress-linear
                          v-if="isLoading"
                          indeterminate
                          color="green"
                        ></v-progress-linear>
                      </template>

                      <template v-slot:item="row">
                        <tr
                          :class="{
                            'cor-row': row.index % 2 !== 0,
                            'primeira-linha-estilo': row.index === 0,
                          }"
                        >
                          <td class="linha" style="width: 5%; font-size: 14px">
                            {{ row.item.id_atendimento }}
                          </td>
                          <td class="linha" style="width: 30%; font-size: 14px">
                            {{ row.item.falecido }}
                            <br />
                            Grau de Relação: {{ row.item.grau_relacao }} <br />
                            Plano: {{ row.item.tipo_plano }}
                            <br />
                          </td>
                          <td class="linha" style="width: 10%; font-size: 14px">
                            {{
                              parseFloat(row.item.valor).toLocaleString(
                                "pt-BR",
                                {
                                  style: "currency",
                                  currency: "BRL",
                                }
                              )
                            }}
                          </td>

                          <td class="linha" style="width: 10%; font-size: 14px">
                            {{ row.item.cidade }}
                          </td>

                          <td class="linha" style="width: 10%; font-size: 14px">
                            {{ row.item.origem }}
                          </td>

                          <td class="linha" style="width: 20%; font-size: 14px">
                            {{ row.item.destino }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>

                    <br />

                    <!-- Totalizador -->
                    <div class="d-flex justify-end">
                      <span style="font-size: 18px; font-weight: bold">
                        Total:
                        {{
                          totalValorDO.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}
                      </span>
                    </div>

                    <br />
                  </base-material-card>
                </v-col>

                <v-col cols="6">
                  <base-material-card
                    icon="mdi-toolbox-outline"
                    title="Total por Plano"
                    color="green"
                    style="
                      margin-top: 20px !important;
                      padding-top: 10px !important;
                    "
                    class="px-5 py-0"
                  >
                    <v-data-table
                      :headers="ranking_four"
                      :items="agrupamento_plano"
                      :items-per-page="10"
                      items-per-page-text="Linhas por página"
                      class="elevation-0"
                    >
                      <br />
                      <br />
                      <br />

                      <template v-slot:top>
                        <v-progress-linear
                          v-if="isLoading"
                          indeterminate
                          color="green"
                        ></v-progress-linear>
                      </template>

                      <template v-slot:item="row">
                        <tr
                          :class="{
                            'cor-row': row.index % 2 !== 0,
                            'primeira-linha-estilo': row.index === 0,
                          }"
                        >
                          <td class="linha" style="width: 55%; font-size: 14px">
                            {{ row.item.agrupamento }}
                          </td>
                          <td class="linha" style="width: 20%; font-size: 14px">
                            {{
                              parseFloat(row.item.valor).toLocaleString(
                                "pt-BR",
                                {
                                  style: "currency",
                                  currency: "BRL",
                                }
                              )
                            }}
                          </td>

                          <td class="linha" style="width: 25%; font-size: 14px">
                            {{ row.item.total }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>

                    <br />

                    <!-- Totalizador -->
                    <div class="d-flex justify-end">
                      <span style="font-size: 18px; font-weight: bold">
                        Total:
                        {{
                          totalValorATP.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}
                      </span>
                    </div>

                    <br />
                  </base-material-card>
                </v-col>

                <v-col cols="6">
                  <base-material-card
                    icon="mdi-toolbox-outline"
                    title="Total por Grau de Relação"
                    color="green"
                    style="
                      margin-top: 20px !important;
                      padding-top: 10px !important;
                    "
                    class="px-5 py-0"
                  >
                    <v-data-table
                      :headers="ranking_four"
                      :items="agrupamento_grau"
                      :items-per-page="10"
                      items-per-page-text="Linhas por página"
                      class="elevation-0"
                    >
                      <br />
                      <br />
                      <br />

                      <template v-slot:top>
                        <v-progress-linear
                          v-if="isLoading"
                          indeterminate
                          color="green"
                        ></v-progress-linear>
                      </template>

                      <template v-slot:item="row">
                        <tr
                          :class="{
                            'cor-row': row.index % 2 !== 0,
                            'primeira-linha-estilo': row.index === 0,
                          }"
                        >
                          <td class="linha" style="width: 55%; font-size: 14px">
                            {{ row.item.agrupamento }}
                          </td>
                          <td class="linha" style="width: 20%; font-size: 14px">
                            {{
                              parseFloat(row.item.valor).toLocaleString(
                                "pt-BR",
                                {
                                  style: "currency",
                                  currency: "BRL",
                                }
                              )
                            }}
                          </td>

                          <td class="linha" style="width: 25%; font-size: 14px">
                            {{ row.item.total }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>

                    <br />

                    <!-- Totalizador -->
                    <div class="d-flex justify-end">
                      <span style="font-size: 18px; font-weight: bold">
                        Total:
                        {{
                          totalValorATP.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}
                      </span>
                    </div>

                    <br />
                  </base-material-card>
                </v-col>

                <v-col cols="6">
                  <base-material-card
                    icon="mdi-toolbox-outline"
                    title="Total por Cidade"
                    color="green"
                    style="
                      margin-top: 20px !important;
                      padding-top: 10px !important;
                    "
                    class="px-5 py-0"
                  >
                    <v-data-table
                      :headers="ranking_four"
                      :items="agrupamento_cidade"
                      :items-per-page="10"
                      items-per-page-text="Linhas por página"
                      class="elevation-0"
                    >
                      <br />
                      <br />
                      <br />

                      <template v-slot:top>
                        <v-progress-linear
                          v-if="isLoading"
                          indeterminate
                          color="green"
                        ></v-progress-linear>
                      </template>

                      <template v-slot:item="row">
                        <tr
                          :class="{
                            'cor-row': row.index % 2 !== 0,
                            'primeira-linha-estilo': row.index === 0,
                          }"
                        >
                          <td class="linha" style="width: 55%; font-size: 14px">
                            {{ row.item.agrupamento }}
                          </td>
                          <td class="linha" style="width: 20%; font-size: 14px">
                            {{
                              parseFloat(row.item.valor).toLocaleString(
                                "pt-BR",
                                {
                                  style: "currency",
                                  currency: "BRL",
                                }
                              )
                            }}
                          </td>

                          <td class="linha" style="width: 25%; font-size: 14px">
                            {{ row.item.total }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>

                    <br />

                    <!-- Totalizador -->
                    <div class="d-flex justify-end">
                      <span style="font-size: 18px; font-weight: bold">
                        Total:
                        {{
                          totalValorATP.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}
                      </span>
                    </div>

                    <br />
                  </base-material-card>
                </v-col>

                <v-col cols="6">
                  <base-material-card
                    icon="mdi-toolbox-outline"
                    title="Total por Origem"
                    color="green"
                    style="
                      margin-top: 20px !important;
                      padding-top: 10px !important;
                    "
                    class="px-5 py-0"
                  >
                    <v-data-table
                      :headers="ranking_four"
                      :items="agrupamento_origem"
                      items-per-page-text="Linhas por página"
                      class="elevation-0"
                    >
                      <br />
                      <br />
                      <br />

                      <template v-slot:top>
                        <v-progress-linear
                          v-if="isLoading"
                          indeterminate
                          color="green"
                        ></v-progress-linear>
                      </template>

                      <template v-slot:item="row">
                        <tr
                          :class="{
                            'cor-row': row.index % 2 !== 0,
                            'primeira-linha-estilo': row.index === 0,
                          }"
                        >
                          <td class="linha" style="width: 55%; font-size: 14px">
                            {{ row.item.agrupamento }}
                          </td>
                          <td class="linha" style="width: 20%; font-size: 14px">
                            {{
                              parseFloat(row.item.valor).toLocaleString(
                                "pt-BR",
                                {
                                  style: "currency",
                                  currency: "BRL",
                                }
                              )
                            }}
                          </td>

                          <td class="linha" style="width: 25%; font-size: 14px">
                            {{ row.item.total }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>

                    <br />

                    <!-- Totalizador -->
                    <div class="d-flex justify-end">
                      <span style="font-size: 18px; font-weight: bold">
                        Total:
                        {{
                          totalValorATP.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}
                      </span>
                    </div>

                    <br />
                  </base-material-card>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </template>
    </v-container>
  </v-app>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import FiltroComponent from "./components/FiltroFuneraria.vue"; // Certifique-se de que o caminho esteja correto
import Funeraria from "../../services/funeraria";
import { ContentLoader } from "vue-content-loader";

export default {
  name: "Obitos",
  components: {
    apexcharts: VueApexCharts,
    FiltroComponent,
    ContentLoader,
  },

  created() {
    (this.selectedStartDate = this.getFirstDayOfMonth()),
      (this.selectedEndDate = this.formatDateBR(new Date()));

    (this.selectedStartDate2 = this.getFirstDayOfMonth()),
      (this.selectedEndDate2 = this.formatDateBR(new Date()));
  },
  tab: null,
  items_bar: [
    "Receita",
    "Atendimentos com autorizações",
    "Detalhamento de óbitos",
  ],

  computed: {
    totalValorSP() {
      return this.servicos_particulares.reduce((total, item) => {
        return total + parseFloat(item.valor || 0);
      }, 0);
    },
    totalValorVI() {
      return this.servicos_particulares_itens.reduce((total, item) => {
        return total + parseFloat(item.valor || 0);
      }, 0);
    },
    totalValorSPP() {
      return this.servicos_plano_previda.reduce((total, item) => {
        return total + parseFloat(item.valor || 0);
      }, 0);
    },

    totalValorSPPI() {
      return this.servicos_plano_previda_itens.reduce((total, item) => {
        return total + parseFloat(item.valor || 0);
      }, 0);
    },

    totalValorPQ() {
      return this.servicos_pequeninos.reduce((total, item) => {
        return total + parseFloat(item.valor || 0);
      }, 0);
    },

    totalValorPQI() {
      return this.servicos_pequeninos_itens.reduce((total, item) => {
        return total + parseFloat(item.valor || 0);
      }, 0);
    },

    totalValorLSC() {
      return this.liberacao_servicos_carencia.reduce((total, item) => {
        return total + parseFloat(item.valor || 0);
      }, 0);
    },
    totalValorDO() {
      return this.detalhe_obito.reduce((total, item) => {
        return total + parseFloat(item.valor || 0);
      }, 0);
    },
    totalValorATP() {
      return this.agrupamento_plano.reduce((total, item) => {
        return total + parseFloat(item.valor || 0);
      }, 0);
    },
  },

  mounted() {
    this.selectedOpcao = "Falecimento";
    //  this.carregarLoad(),
    //  this.dashboard();
  },

  data() {
    return {
      ranking_one: [
        { text: "Atend.", value: "id_atendimento" },
        { text: "Falecido", value: "falecido" },
        { text: "Valor", value: "valor" },
      ],
      ranking_two: [
        { text: "Item", value: "item" },
        { text: "Valor", value: "valor" },
      ],
      ranking_three: [
        { text: "Atend.", value: "id_atendimento" },
        { text: "Falecido", value: "falecido" },
        { text: "Valor", value: "valor" },
        { text: "Cidade", value: "cidade" },
        { text: "Origem", value: "origem" },
        { text: "Destino", value: "destino" },
      ],
      ranking_four: [
        { text: "Agrupamento", value: "agrupamento" },
        { text: "Valor", value: "valor" },
        { text: "Qtd.", value: "total" },
      ],
      ranking_five: [
        { text: "Atend.", value: "id_atendimento" },
        { text: "Falecido", value: "falecido" },
        { text: "Valor", value: "valor" },
        { text: "Item", value: "item" },
      ],
      ranking_six: [
        { text: "Agrupamento", value: "agrupamento" },
        { text: "Qtd", value: "total" },
        { text: "Valor Total", value: "valor" },
      ],
      activeTab: 0, // Controla a aba ativa (começa na primeira aba)
      servicos_particulares: [],
      servicos_particulares_itens: [],
      servicos_plano_previda_itens: [],
      servicos_pequeninos_itens: [],
      agrupamento_plano: [],
      agrupamento_grau: [],
      recebimento_radar: [],
      agrupamento_cidade: [],
      agrupamento_origem: [],
      servicos_pequeninos: [],
      detalhe_obito: [],
      liberacao_servicos_carencia: [],
      servicos_plano_previda: [],
      produto: "Todos",
      empresa: "",
      selectedCompany: "Todas",
      selectedType: "Todos",
      selectedOpcao: "Todas",
      selectMode: "Vencimento",
      selectedStartDate: "",
      selectedEndDate: "",
      isLoading: false,
      modos: ["Falecimento", "Atendimento"],
      showFilter: false,
      showProgress: false,
      showFilterDownload: false,
      opcoes: ["Todas", "COM SEGURO", "SEM SEGURO"],
      empresas: [
        "CEMITERIO PREVIDA",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "A FLOR DO CAFÉ",
        "Todas",
      ],
      tipos: ["Todos", "Planos"],
      tipos_funerarios: ["Todos"],
    };
  },

  methods: {
    isDateValid(dateString) {
      // Verifica se a string é uma data válida
      const date = new Date(dateString);
      return !isNaN(date.getTime());
    },

    filterData(valores) {
      this.carregarLoad(), (this.isLoading = true);
      let nova_consulta = false;
      this.selectedType = "Todos";
      this.selectedCompany = "Previda";
      this.selectMode = valores.selectMode;
      this.selectedOpcao = valores.selectMode;
      this.selectedStartDate = valores.selectedStartDate;
      this.selectedEndDate = valores.selectedEndDate;
      this.produto = "Todos";
      //this.gf01();
      this.dashboard();
    },

    getFirstDayOfMonth() {
      const dataAtual = new Date();
      const primeiroDiaDoMes = new Date(
        dataAtual.getFullYear(),
        dataAtual.getMonth(),
        1
      );
      return this.formatDateBR(primeiroDiaDoMes);
    },

    formatDateBR(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const year = parsedDate.getFullYear();
      return `${day}/${month}/${year}`;
    },

    carregarLoad() {
      this.bool_03 = true;
    },

    async dashboard() {
      this.isLoading = true;
      const formattedStartDate = converteDataParaFormatoISO(
        this.selectedStartDate
      );
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);
      const diferencaEmDias = this.calcularDiferencaEntreDatas(
        formattedStartDate,
        formattedEndDate
      );

      if (diferencaEmDias > 90) {
        this.isLoading = false;
        this.showFilter = true;
        this.showProgress = false;
        this.dias = 90;
        return;
      }

      Funeraria.servicos_particulares(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        this.selectedOpcao,
        this.produto
      )
        .then((response) => {
          if (response.status === 200) {
            this.servicos_particulares = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.isLoading = false;
        });

      Funeraria.servicos_particulares_itens(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        this.selectedOpcao,
        this.produto
      )
        .then((response) => {
          if (response.status === 200) {
            this.servicos_particulares_itens = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.isLoading = false;
        });

      Funeraria.servicos_plano_itens(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        this.selectedOpcao,
        this.produto
      )
        .then((response) => {
          if (response.status === 200) {
            this.servicos_plano_previda_itens = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.isLoading = false;
        });

      Funeraria.servicos_plano_previda(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        this.selectedOpcao,
        this.produto
      )
        .then((response) => {
          if (response.status === 200) {
            this.servicos_plano_previda = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.isLoading = false;
        });

      Funeraria.servicos_pequeninos(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        this.selectedOpcao,
        this.produto
      )
        .then((response) => {
          if (response.status === 200) {
            this.servicos_pequeninos = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.isLoading = false;
        });

      Funeraria.liberacao_servicos_carencia(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        this.selectedOpcao,
        this.produto
      )
        .then((response) => {
          if (response.status === 200) {
            this.liberacao_servicos_carencia = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.isLoading = false;
        });

      Funeraria.detalhe_obito(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        this.selectedOpcao,
        this.produto
      )
        .then((response) => {
          if (response.status === 200) {
            this.detalhe_obito = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.isLoading = false;
        });

      Funeraria.agrupamento(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        "plano",
        this.selectedOpcao,
        this.produto
      )
        .then((response) => {
          if (response.status === 200) {
            this.agrupamento_plano = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.isLoading = false;
        });

      Funeraria.agrupamento(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        "grau",
        this.selectedOpcao,
        this.produto
      )
        .then((response) => {
          if (response.status === 200) {
            this.agrupamento_grau = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.isLoading = false;
        });

      Funeraria.agrupamento(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        "cidade",
        this.selectedOpcao,
        this.produto
      )
        .then((response) => {
          if (response.status === 200) {
            this.agrupamento_cidade = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.isLoading = false;
        });

      Funeraria.agrupamento(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        "origem",
        this.selectedOpcao,
        this.produto
      )
        .then((response) => {
          if (response.status === 200) {
            this.agrupamento_origem = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.isLoading = false;
        });

      Funeraria.servicos_pequeninos_itens(
        formattedStartDate,
        formattedEndDate,
        this.selectedCompany,
        this.selectedType,
        "Todos",
        this.selectedOpcao,
        this.produto
      )
        .then((response) => {
          if (response.status === 200) {
            this.servicos_pequeninos_itens = response.data;
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.isLoading = false;
        });
    },

    download_xls() {
      //this.showProgress = true;
      const formattedStartDate = converteDataParaFormatoISO(
        this.selectedStartDate
      );
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);
      const diferencaEmDias = this.calcularDiferencaEntreDatas(
        formattedStartDate,
        formattedEndDate
      );

      if (diferencaEmDias > 90) {
        this.isLoading = false;
        this.showFilter = true;
        this.dias = 90;
        return;
      }

      this.showFilterDownload = true;
    },

    formatarMoeda(valor) {
      // Verifica se o valor é numérico
      if (isNaN(valor)) {
        return "Valor inválido";
      }

      // Formata o valor como moeda brasileira (BRL)
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    getStatus(status) {
      switch (status) {
        case "PARQUE DAS FLORES":
          return "orange darken-2";
        case "CEMITERIO PREVIDA":
          return "blue lighten-1";
        case "MEMORIAL PARQUE MACEIÓ":
          return "green lighten-1";
        case "PARQUE DO AGRESTE":
          return "cyan lighten-1";
        case "PREVIDA":
          return "blue lighten-1";

        default:
          "success";
      }
    },

    calcularComissao: function (empresa, resultado, comissao, original, pago) {
      if (empresa === "PREVIDA") {
        if (resultado < 0) {
          // Se o resultado for negativo, retorna a diferença entre pago e original
          return pago - original;
        } else {
          // Se o resultado não for negativo, retorna a comissão
          return comissao;
        }
      } else {
        // Se a empresa for diferente de "Previda", retorna a comissão
        return comissao;
      }
    },

    format_hora(valor) {
      return Math.floor(valor / 60) + "h " + (valor % 60) + "min";
    },

    calcularDiferencaEntreDatas(dataInicial, dataFinal) {
      const data1 = new Date(dataInicial);
      const data2 = new Date(dataFinal);

      // Verifique se as datas são válidas
      if (isNaN(data1) || isNaN(data2)) {
        return NaN; // Retorna NaN se uma das datas for inválida
      }

      const diferencaEmMilissegundos = data2 - data1;
      const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);

      return diferencaEmDias;
    },

    clear() {
      this.$refs.form.reset();
    },
  },
};

function formatMoeda(value) {
  // Use o método toLocaleString com a opção style: 'currency' para formatar como moeda

  if (value === undefined || value === null) {
    return "R$ 0,00"; // Ou você pode retornar 0 como número, se preferir.
  }

  return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  //return 0
  //return value
}

function converteDataParaFormatoISO(dataNoFormatoBR) {
  const partes = dataNoFormatoBR.split("/");
  if (partes.length === 3) {
    const [dia, mes, ano] = partes;
    return `${ano}-${mes}-${dia}`;
  }
  return null; // Retorna null se a data estiver em um formato inválido
}
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 90px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto !important;
  margin: -12px;
}

/* Defina uma classe para preencher a largura horizontalmente e centralizar verticalmente */
.fill-width {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}

.v-menu__content {
  box-shadow: none !important;
  top: 4px !important;
}
/* Centralize horizontalmente */
.justify-center {
  justify-content: center;
}

.gray-row {
  background-color: #e7f1ff; /* ou qualquer outra cor cinza que você preferir */
}
.cor-row {
  background-color: #f8ded4;
  transition: none !important; /* Desativa a transição de cor */
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.no-hover-effect.v-data-table tbody tr:hover {
  color: #3055a4;
}
.card-container {
  display: flex;
  justify-content: space-around; /* ou outro alinhamento que desejar */
}

.primeira-linha-estilo {
  font-size: 5px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
</style>
